<template>
  <div
    class=""
    style="position: relative;">
    <div
      v-if="adv.status==='canceled' || !plan.adv_enabled || !adv.promoteur.plan.adv_enabled"
      class="frontdrop"></div>
    <div
      class="columns is-gapless has-background-reserved is-padding has-text-white is-marginless-bottom"
      v-if="isAdmin && isPromoteur">
      <div class="column is-5 is-padding-top-large is-padding-bottom-large">
        <span class="is-uppercase">Taux commercialisation programme</span>
      </div>
      <div class="column is-4 columns is-gapless is-column is-margin-left">
        <div class="">
          <r-label
            :for="'taux_com'"
            :is-required="false"
            label="Taux de commercialisation"
            class="label has-text-white is-uppercase"></r-label>
          <div class="field has-addons">
            <v-input
              :name="'taux_com'"
              @input="val => tauxComInput(val)"
              :model="adv.remuneration"
              :errors-bag="errors"
              data-vv-value-path="val"
              classes="has-text-centered w90p"
              :max="100"
              :number="true"
              input-type="number"
              data-vv-as=" "
              icon="fa-percentage"
              v-validate="'required|decimal:2'"
              :has-incrementations="true"
              :step="0.1">
              <div class="control">
                <a class="button is-static is-border is-square">
                  <span class="icon"><i class="fas fa-percentage"></i></span>
                </a>
              </div>
            </v-input>
            <div
              class="control"
              v-if="displayNewTauxComButton">
              <a
                @click="newTauxCom"
                class="button is-success is-square tooltip is-tooltip-right"
                data-tooltip="Valider la modification du taux">
                <span class="icon"><i class="fas fa-save"></i></span>
              </a>
            </div>
            <div
              class="control"
              v-if="displayNewTauxComButton">
              <a
                @click="undoCom"
                data-tooltip="Annuler la modification du taux"
                class="button tooltip is-tooltip-right is-square is-draft">
                <span class="icon has-text-white"><i class="fas fa-times"></i></span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-padding-top-large is-padding-bottom-large has-text-right">
        <!-- v-if="!tauxComInputEnabled" -->
        <span class="has-text-weight-bold">{{ caPromoteur }} € HT</span>
      </div>
    </div>

    <div class="is-border-left is-border-right">
      <seller-facturation
        v-for="(share, i) in sale.users_in_sale"
        :key="share.seller"
        :share="share"
        :index="i"></seller-facturation>
    </div>
    <div
      v-if="sale.users_in_sale.length < 3 && isAdmin && isPromoteur"
      class="row-width-actions-bar">
      <button
        @click="openUserSelection('simple')"
        class="page-header-btn button is-dark is-fullwidth is-radiusless">
        <span>Ajouter un vendeur</span>
      </button>
    </div>

    <div
      class="columns is-gapless is-padding has-background-reserved has-text-white is-margin-top-xsmall"
      v-if="isAdmin && isPromoteur">
      <div class="column is-uppercase">
        Restant sur vente
      </div>
      <div class="column is-uppercase has-text-right">
        <div class="has-text-weight-bold">
          {{ margePromoteurHT }} € HT
        </div>
        <!-- <div>{{margePromoteurTTC}} € TTC</div> -->
      </div>
    </div>

    <div
      v-if="isAdmin && isPromoteur || currentUser.active_all_contact"
      class="has-background-white">
      <div class="row-width-actions-bar columns is-gapless is-marginless">
        <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
          <span class="is-uppercase title is-6">Commentaire</span>
        </div>
        <div class="column is-narrow is-border-left">
        </div>
      </div>
      <template v-if="openComment">
        <div
          v-if="!openCommentWysi && comment"
          @click="openWysiwyg"
          class="vadDiscussion is-border-top"
          style="cursor: pointer;">
          <div
            class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
            <div
              class="content"
              v-if="(isAdmin || currentUser.active_all_contact) && comment"
              v-html="comment"></div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div class="">
                <button
                  @click="openWysiwyg"
                  class="is-min-height-full">
                  <span class="icon is-small"><i class="fal fa-edit"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="is-border-top columns is-gapless">
          <div class="column">
            <wysiwyg-editor
              :light="true"
              :tooltip-top="true"
              :model="comment"
              @change="val => comment = val"
              class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
            </wysiwyg-editor>
          </div>
          <div class="actionsOnRow actionsOnRow--vertical">
            <div>
              <button
                @click="patchComment()"
                type="button"
                class="button"
                :class="[(baseComment !== comment) ? 'is-success' : 'is-info']"
                :disabled="(baseComment === comment)">
                <span class="icon is-small">
                  <i
                    v-if="loadComment"
                    class="fas fa-spinner fa-spin"></i>
                  <i
                    v-else
                    class="fal fa-save"></i>
                </span>
              </button>
            </div>
            <div class="">
              <button
                :disabled="!baseComment"
                type="button"
                :class="{'actionsOnRow-btn--hoverIsDanger': comment}"
                @click="comment?openCommentWysi = false:null; comment = baseComment">
                <span class="icon is-small"><i class="fal fa-times"></i></span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { clone } from 'lodash'
import { Adv, Error, Quickview } from '@/mixins'
import { mapState } from 'vuex'

export default {
  name: 'Commercialisation',
  components: {
    SellerFacturation: () => import('./SellerFacturation')
  },
  mixins: [Adv, Error, Quickview],
  data () {
    return {
      tauxComInputEnabled: false,
      displayNewTauxComButton: false,
      save: false,
      service: this.$api.advService,
      editShare: false,
      error: {},
      displayInlineError: true,
      showEditRem: false,
      savedTauxCom: null
    }
  },
  computed: {
    ...mapState(['quickview']),
    /**
      * sellers pk
      * @returns {array} - array of pk
      */
    sellersPk () {
      if (this.sale.users_in_sale && this.sale.users_in_sale.length) {
        return this.sale.users_in_sale.map(x => x.user.pk)
      } else {
        return []
      }
    },
    /**
      * comm ttc
      * @returns {Number}
      */
    comTTC () {
      return Math.floor(this.adv.sale_price_ttc * this.adv.remuneration / 100)
    },
    /**
      * comm ht
      * @returns {Number}
      */
    comHT () {
      return Math.floor(this.adv.sale_price_ttc * this.adv.remuneration / 100)
    },
    /**
      * taux
      * @returns {Number}
      */
    taux () {
      let sellerPercent = this.sale.users_in_sale.reduce((accum, x) => x.remuneration + accum, 0)
      return this.adv.remuneration - sellerPercent
    },
    // margePromoteurTTC () {
    //   return Number((this.taux / 100) * this.adv.sale_price_ttc).toFixed(2)
    // },
    /**
      * marge promoteur HT
      * @returns {Number}
      */
    margePromoteurHT () {
      return Number((this.taux / 100) * this.adv.sale_price_ht).toFixed(2)
    },
    /**
      * ca promoteur
      * @returns {Number}
      */
    caPromoteur () {
      return Number(this.adv.sale_price_ht * (this.adv.remuneration / 100)).toFixed(2)
    }
  },
  watch: {
    quickview ({ mode, params, results }) {
      if (results && mode === 'USER_SELECTION') {
        if (results.entities.length) {
          this.addUser(results.entities[0])
          this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        } else {
          this.$toasted.error('Veuillez séléctionner un manager')
        }
      }
    }
  },
  created () {
    this.savedTauxCom = clone(this.adv.remuneration)
  },
  methods: {
    /**
      * new taux com
      * patch adv
      */
    async newTauxCom () {
      let payload = {
        remuneration: this.adv.remuneration
      }
      try {
        await this.$store.dispatch('patchAdv', payload)
        this.savedTauxCom = clone(this.adv.remuneration)
        this.displayNewTauxComButton = false
        this.$toasted.success('Taux de commercialisation mis a jour')
      } catch (e) {
        console.log(e)
        this.$toasted.error('Erreur lors de la mise à jour')
      }
    },
    /**
      * input taux com update
      */
    tauxComInput (val) {
      this.adv.remuneration = val
      this.displayNewTauxComButton = true
    },
    /**
      * undo remuneration
      */
    undoCom () {
      this.adv.remuneration = this.savedTauxCom
      this.displayNewTauxComButton = false
    },
    /**
      * open user selection
      */
    openUserSelection (type = 'multiple') {
      let params = {
        facets: {
          USER: []
        },
        selectType: type,
        mode: 'store'
      }
      for (let seller of this.sellersPk) {
        params.facets.USER.push([`pk:-${seller}`])
      }
      this.openUserSelectionQuickview(params)
    },
    /**
      * add user
      */
    async addUser (user) {
      // let data = null
      let payload = {
        user: user.pk,
        remuneration: 0
      }
      let resa = null
      let sell = null
      try {
        let { data } = await this.$api.axios.post(`sales/${this.sale.pk}/users`, payload)
        this.sale.users_in_sale.push(data)
        resa = await this.$api.axios.get(`reservations/${this.adv.pk}/`)
        sell = resa.data.seller_to_send
        sell.push(data.user)
        let dataToSend = {
          seller_to_send: sell
        }
        this.$store.commit('modifyCurrentAdv', { key: `seller_to_send`, value: sell })
        await this.$api.axios.patch(`reservations/${this.adv.pk}`, dataToSend)
        this.$toasted.success('Vendeur ajouté')
      } catch (err) {
        console.log(err)
        this.handleError(err)
      }
    }
  }
}
</script>
